const mvpFAQ = [
  {
    question: 'What species can sign up for Healthy Pet&nbsp;+?',
    answer: 'This membership is for dogs and cats.',
  },
  {
    question: 'Can I sign up more than one pet for Healthy Pet&nbsp;+?',
    answer: 'Yes! You can get all your dog and cat companions signed up.',
  },
  {
    question: 'How many pets can I put under one plan?',
    answer: 'One. The Healthy Pet&nbsp;+ membership plan is on a per-pet basis.',
  },
  {
    question: 'I have already purchased a membership for one pet, how do I add another pet/membership?',
    answer: 'You can sign up additional pets via the&nbsp;<a href="/#/plans/0/signup">Healthy Pet&nbsp;+ online portal</a>.',
  },
  {
    question: 'Can I transfer the membership to another pet?',
    answer: 'No. Memberships are not transferable between pets.',
  },
]

const allFAQ = [
  {
    title: `Healthy Pet\xa0+ Membership and Eligibility`,
    faqs: [
      {
        question: `What do I get for my $14.95 per month?` ,
        answer: `As long as your membership is active, you receive unlimited veterinary examinations<sup>1</sup> and 10% off veterinary services, and $5 nail trims. `,
      },
      {
        question: `What species can sign up for Healthy Pet&nbsp;+?`,
        answer: `This membership is for dogs and cats. `,
      },
      {
        question: `Can I use the discounts the same day I sign up?`,
        answer: `Yes, you will pay the initial $14.95 fee for the first month and then they can use the benefits that same day!  Payment for membership will automatically be deducted around the same time each month.`,
      },
      {
        question: `Can I use additional discounts and / or promotions for services? `,
        answer: `No. Only one discount can be used at a time. Clients can; however, take advantage of product rebates through the vendor. `,
      },
      {
        question: `Can I still redeem product rebates / discounts from manufacturers? `,
        answer: `Yes. `,
      },
      {
        question: `Are tech exams included in Healthy Pet&nbsp;+? `,
        answer: `Yes. That is included in the definition of an "exam".`,
      },
      {
        question: `Are there any exclusions to the exams included in Healthy Pet&nbsp;+? `,
        answer: `Yes. Currently excluded are After Hour Exams and All Health Certificates. However, exams-types excluded from Unlimited still qualify for the 10% discount.`,
      },
      {
        question: `Can I come in whenever I want? `,
        answer: `The Healthy Pet&nbsp;+ Membership does not indicate priority scheduling or immediate availability for services. We still request that you call ahead to inquire about availability for an appointment, or to check status of availability to accommodate same day services without an appointment. `,
      },
      {
        question: `What if I must go somewhere else for more test / treatment? `,
        answer: `There may be occasions where a referral for care is recommended to complete care; the Healthy Pet&nbsp;+ benefits do not transfer to other locations.`,
      },
      {
        question: `May I take my pet to another Pathway location to redeem benefits? `,
        answer: `No, this Healthy Pet&nbsp;+ membership program is location specific.`,
      },
      {
        question: `How many pets can I put under one plan? `,
        answer: `One, the Healthy Pet&nbsp;+ membership plan is on a per-pet basis.  `,
      },
      {
        question: `How will you know my pet is a Healthy Pet&nbsp;+ member? `,
        answer: `Membership is identified in the pet’s records. You don’t need to bring any identification with you.`  ,
      },
    ]
  },
  {
    title: 'Sign up',
    faqs: [
      {
        question: `Where do I sign up? `,
        answer: `Sign up can be done via the&nbsp;<a href="/#/plans/0/signup">Healthy Pet&nbsp;+ online portal</a>.`,
      },
      {
        question: `Is there a Healthy Pet&nbsp;+ Membership App? `,
        answer: `No app is available currently. The Healthy Pet&nbsp;+ online portal can be accessed via your browser. `,
      },
      {
        question: `Can I sign up more than one pet for Healthy Pet&nbsp;+? `,
        answer: `Yes! You can get all your dog and cat companions signed up. `,
      },
      {
        question: `I have already purchased a membership for one pet, how do I add another pet/membership? `,
        answer: `You can sign up additional pets via the&nbsp;<a href="/#/plans/0/signup">Healthy Pet&nbsp;+ online portal</a>.`
      },
      {
        question: `Do I need a Credit Card to sign up? `,
        answer: `Yes, but a debit card works as well as long as there is a logo on the front of a major credit card company (Visa, Mastercard, American Express, etc).`,
      },
    ]
  },
  {
    title: 'Payment',
    faqs: [
      {
        question: `Is there a minimum commitment period for the Healthy Pet&nbsp;+ membership?`,
        answer: `The initial membership term is for 12 months, starting on the day you sign up. After 12 months, the membership will auto-renew for another 12-month term.`,
      },
      {
        question: `Can I come in and pay cash before payment is due? `,
        answer: `No, automatic payment via a credit card is the only way to pay for membership. `,
      },
      {
        question: `Can I use a pre-paid card as a form of payment for the Healthy Pet&nbsp;+ membership? `,
        answer: `For the payment to successfully process, the card must be attached to data associated with the owner of the card (such as address and zip code). So, generic pre-paid cards that have no association to the person will likely not work when attempting to use as a form of payment. Not all forms of pre-paid cards have been tested, though your best option is to contact your bank and get a pre-paid card that is attached to your identity to satisfy the validation needed to be able to sign up for a recurring membership program. While some forms of pre-paid cards may work, when attached to the appropriate data validation, we cannot promise all forms will work. `,
      },
      {
        question: `Can ScratchPay or CareCredit be used for the membership payment? `,
        answer: `No. We currently only accept major credit cards (Visa, Mastercard, American Express, Discover, JCB, Diners Club).`,
      },
      {
        question: `What about international credit cards?`,
        answer: `In some cases international credit cards may have a zip code that includes letters. This will likely cause some issues with processing. When inputting a credit card with an international zip code, try 00000 in the zip code field. If that fails to process, you will need to call your bank to ask for processing instructions.`,
      },
      {
        question: `Where can I update my credit card information?`,
        answer: `<p>Please login to your account at&nbsp;<a href="https://healthpetmembership.recurly.com/">https://healthpetmembership.recurly.com</a> with the email address you used during sign up.</p>`,
      },
      {
        question: `Can I use different payment methods for each pet signed up for a Healthy Pet&nbsp;+ membership? `,
        answer: `As long as the payment methods are credit cards, yes. Simply go through the enrollment process for each pet online (after selecting the location and plan, complete the enrollment for each pet separately).`,
      },
      {
        question: `What happens if I don't pay for my membership? (issue with card, cancelled card, technical issue) `,
        answer: `<p>You will be notified by email once your form of payment declines. Processing attempts will be made until successful up to three more times and by the tenth day, the membership will be terminated.  To update your credit card information please login to your account at&nbsp;<a href="https://healthpetmembership.recurly.com/">https://healthpetmembership.recurly.com</a> with the email address you used during sign up. You can also reach out to <a style="display: inline; width: 400px" href="mailto:support@healthypet-plus.com">support@healthypet-plus.com</a>.</p>`,
      },
      {
        question: `If I become past due on my membership, can I reactivate it? `,
        answer: `<p>Please contact <a style="display: inline; width: 400px" href="mailto:support@healthypet-plus.com">support@healthypet-plus.com</a> to update your payment information. If you are over 10 days past the due date, your subscription will have been canceled and you may need to become current before re-enrolling in the program.</p>`,
      },
      {
        question: `Will I still be able to receive member benefits for my pet if my account has a balance due or is on hold pending updated payment? `,
        answer: `No. Your Healthy Pet&nbsp;+ status must be active to be able to receive membership benefits.`,
      },
      {
        question: `What should I do if it looks like the card declined? `,
        answer: `You may need to contact the bank associated to the card to discover any rejection/decline issues. `,
      },
      {
        question: `What can trigger a credit card rejection? `,
        answer: `Email on file, zip code incorrect, card number improperly entered, CVV code incorrect/missing, expiration incorrection typed (must be MM/YY), possible mismatch of the name, insufficient funds, etc. Please contact your bank for more information. `,
      },
    ]
  },
  {
    title: 'Transfers and Healthy Pet + Membership Terminations',
    faqs: [
      {
        question: `Can I transfer the membership to another pet?`,
        answer: `No. Memberships are not transferable between pets.`,
      },
      {
        question: `If I adopt my pet to another home - can I transfer the Healthy Pet&nbsp;+ membership to the new family? `,
        answer: `No, your current membership would need to be cancelled. And the new family would need to initiate their own Healthy Pet&nbsp;+ Membership for that pet. `,
      },
      {
        question: `How do I cancel a Healthy Pet&nbsp;+ Membership? `,
        answer: `<p>Please contact <a style="display: inline; width: 400px" href="mailto:support@healthypet-plus.com">support@healthypet-plus.com</a> and they will process the remaining balance of the initial term.</p>`,
      },
      {
        question: `What is the cancellation fee? `,
        answer: `Cancellation fee is the remaining commitment period balance. As an example, if canceling the in the 9th month of enrollment, the cancellation fee will be three months (12 – 9) of subscription fees.`,
      },
      {
        question: `I’m moving, do I still need to pay a cancellation fee? `,
        answer: `<p>The cancellation fee will be waived if moving at least 50 miles from your current location. Please contact <a style="display: inline; width: 400px" href="mailto:support@healthypet-plus.com">support@healthypet-plus.com</a>.</p>`,
      },
      {
        question: `What do I do if my pet passes away? `,
        answer: `We will mark the pet deceased in your account and cancel your membership without termination fees, starting the following month of the billing period after we are first notified. `,
      },
    ]
  },
]

export { mvpFAQ, allFAQ }
